import { Component, OnInit } from '@angular/core';
import { LandingpageService } from './landingpage.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../assets/i18n/configuration/configuration.json';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css'],
  providers: [LandingpageService]
})


export class LandingpageComponent implements OnInit {

  //data={};
  items = [];
  isLoading = false;
  languageConfiguration: any;
  textDir:any;
  constructor( 
              public translate: TranslateService,
              private router: Router,
              private landingpageService: LandingpageService) { 
                this.languageConfiguration = (languageConfig as any).default;
                translate.addLangs([this.languageConfiguration.languages]);
                translate.setDefaultLang(this.languageConfiguration.defaultLang);
                let selectedLang = sessionStorage.getItem('selectedLang');
                this.textDir = sessionStorage.getItem('textDir');
                let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
                if(selectedLang){
                  translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
                } else {
                  const browserLang = translate.getBrowserLang();                  
                  translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
                }               
              }

  ngOnInit() {
    const temp = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (temp){
      this.getJsonData();
    }else{
      this.router.navigate(['/login']);
    }
  }
  getJsonData() {
    this.landingpageService.getData().subscribe(
      (response) => {
        if (response.elements) {
          this.items = response.elements;
          this.isLoading = true;
        } else {
          this.router.navigate(['/login']);
        }
      },
      (err) => {
        this.router.navigate(['/login']);
      },
      () => {
       // console.log("COMPLETED");
      }
    );
  }
  dispRole() {
    const temp = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    let dispRole = '';
    if(temp){
      let leadType: object | null;
      leadType = temp.role.lead;
      if (leadType){
      dispRole = temp.role.lead.type + ' ' + temp.role.desc.toLowerCase();
      } else{
      dispRole = temp.role.desc;
      }
    }    
    return dispRole;
  }
}
